import { Link } from "react-router-dom";
import { ArrowRight, Heart, Sparkles, BadgeCheck } from "lucide-react";
import { IMAGES } from "../../data/site";
import { SectionEyebrow } from "../SectionEyebrow";

const HERO_AVATARS = [
    { id: "av-children", img: IMAGES.children_community },
    { id: "av-elderly", img: IMAGES.elderly_care },
    { id: "av-painting", img: IMAGES.volunteer_painting },
];

export const HomeHero = () => (
    <section className="relative overflow-hidden topo-bg" data-testid="hero-section">
        <div
            className="absolute inset-0 opacity-[0.06] pointer-events-none"
            style={{ backgroundImage: `url(${IMAGES.hero_topo})`, backgroundSize: "cover", backgroundPosition: "center" }}
        />
        <div className="container-fe relative pt-16 lg:pt-24 pb-20 lg:pb-28 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
            <div className="lg:col-span-7 relative z-10">
                <div className="animate-fade-up">
                    <SectionEyebrow>15 años transformando el Tolima</SectionEyebrow>
                </div>
                <h1 className="mt-6 font-display font-bold text-brand-navy text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.05] tracking-tight animate-fade-up delay-100">
                    Transformando vidas desde el{" "}
                    <span className="relative inline-block">
                        <span className="relative z-10 text-brand-green">territorio</span>
                        <span className="absolute left-0 right-0 bottom-1 h-3 bg-brand-green/15 -z-0 rounded-sm" />
                    </span>{" "}
                    y la acción social.
                </h1>
                <p className="mt-7 text-lg lg:text-xl text-muted-foreground max-w-xl leading-relaxed animate-fade-up delay-200">
                    En Ibagué y Tolima trabajamos a favor de la infancia y las comunidades en
                    condición de vulnerabilidad promoviendo el bienestar y el desarrollo integral
                    de nuestros niños, niñas y adolescentes en su entorno.
                </p>
                <div className="mt-9 flex flex-wrap gap-3 animate-fade-up delay-300">
                    <Link to="/donar" data-testid="hero-donate-button" className="btn-primary-pill">
                        <Heart size={16} className="fill-white" /> Donar ahora
                    </Link>
                    <Link to="/voluntariado" data-testid="hero-volunteer-button" className="btn-secondary-pill">
                        Ser voluntario <ArrowRight size={16} />
                    </Link>
                    <Link to="/impacto" data-testid="hero-projects-button" className="btn-ghost-pill">
                        Conoce los proyectos
                    </Link>
                </div>

                <div className="mt-12 flex items-center gap-5 animate-fade-up delay-400">
                    <div className="flex -space-x-3">
                        {HERO_AVATARS.map((a) => (
                            <div key={a.id} className="h-11 w-11 rounded-full ring-2 ring-white overflow-hidden bg-muted">
                                <img src={a.img} alt="" className="w-full h-full object-cover" />
                            </div>
                        ))}
                    </div>
                    <div className="text-sm">
                        <div className="font-semibold text-brand-navy flex items-center gap-1.5">
                            <BadgeCheck size={14} className="text-brand-green" /> Reconocidos por Aflora
                        </div>
                        <div className="text-muted-foreground text-xs">Programa Fundación Bolívar Davivienda</div>
                    </div>
                </div>
            </div>

            <div className="lg:col-span-5 relative h-[500px] lg:h-[620px] animate-scale-in delay-200">
                <div className="absolute top-0 right-0 w-[72%] h-[58%] rounded-3xl overflow-hidden shadow-2xl ring-4 ring-white">
                    <img src={IMAGES.children_community} alt="Comunidad reunida en evento" className="w-full h-full object-cover" />
                </div>
                <div className="absolute top-[30%] left-0 w-[55%] h-[44%] rounded-3xl overflow-hidden shadow-xl ring-4 ring-white">
                    <img src={IMAGES.volunteer_painting} alt="Voluntario pintando con niñas" className="w-full h-full object-cover" />
                </div>
                <div className="absolute bottom-0 right-2 w-[50%] h-[40%] rounded-3xl overflow-hidden shadow-xl ring-4 ring-white">
                    <img src={IMAGES.child_gift} alt="Niño con regalo" className="w-full h-full object-cover" />
                </div>
                <div className="absolute -top-2 left-[30%] bg-white rounded-2xl shadow-lg px-4 py-3 flex items-center gap-2 ring-1 ring-black/5">
                    <Sparkles size={16} className="text-brand-green" />
                    <span className="text-xs font-semibold text-brand-navy">+7.500 vidas impactadas</span>
                </div>
            </div>
        </div>
    </section>
);
